import { useState, useEffect } from "react";
import { useAuth }     from "@context/AuthContext";
import axios           from "axios";
import { API_BASE, PROFILE_IMG_BASE } from "@config/env";

const post = (ep, fields) => { const fd=new FormData(); Object.entries(fields).forEach(([k,v])=>fd.append(k,v)); return axios.post(`${API_BASE}${ep}`,fd).then(r=>r.data).catch(()=>null); };

export default function EditFirmOwnerPage() {
  const { userSlug } = useAuth();

  const [loading,   setLoading]   = useState(true);
  const [details,   setDetails]   = useState(null);
  const [form,      setForm]      = useState({ firstName:"", lastName:"", jobRole:"", bio:"" });
  const [loginEmail,setLoginEmail]= useState("");
  const [avatar,    setAvatar]    = useState(null);
  const [busy,      setBusy]      = useState(false);
  const [avatarBusy,setAvatarBusy]= useState(false);
  const [success,   setSuccess]   = useState("");
  const [error,     setError]     = useState("");

  const set = (k, v) => setForm(f => ({...f, [k]:v}));

  useEffect(() => {
    if (!userSlug) { setLoading(false); return; }
    post("get-firm-owner-details", { user_slug: userSlug }).then(data => {
      const d = data?.firm_owner_details || data?.data?.firm_owner_details;
      if (d) {
        setDetails(d);
        setLoginEmail(d.login_details?.user_email || "");
        setForm({
          firstName: d.profile_details?.first_name  || "",
          lastName:  d.profile_details?.last_name   || "",
          jobRole:   d.profile_details?.user_profile_role || "",
          bio:       d.profile_details?.profile_bio  || "",
        });
        const img = d.profile_details?.profile_image_path;
        if (img) setAvatar(PROFILE_IMG_BASE + img);
      }
      setLoading(false);
    });
  }, [userSlug]);

  const handleSave = async () => {
    if (!form.firstName.trim() || !form.lastName.trim()) { setError("First and last name are required"); return; }
    setBusy(true); setError(""); setSuccess("");
    const res = await post("update-profile-basic-info", {
      current_user_slug: userSlug,
      user_slug:         userSlug,
      first_name:        form.firstName,
      last_name:         form.lastName,
      user_profile_role: form.jobRole,
      profile_bio:       form.bio,
      report_to:         "",
    });
    setBusy(false);
    if (res?.status === 1) setSuccess(res.message || "Profile updated!");
    else setError(res?.message || "Update failed. Please try again.");
    setTimeout(() => { setSuccess(""); setError(""); }, 4000);
  };

  const handleAvatarUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setAvatar(URL.createObjectURL(file));
    setAvatarBusy(true);
    const fd = new FormData();
    fd.append("user_slug", userSlug);
    fd.append("file", file);
    const res = await axios.post(`${API_BASE}user-avatar-upload`, fd).then(r=>r.data).catch(()=>null);
    setAvatarBusy(false);
    if (res?.status === 1) setSuccess("Avatar updated!");
    else setError("Avatar upload failed.");
    setTimeout(() => { setSuccess(""); setError(""); }, 4000);
  };

  const Field = ({ label, fKey, type="text", textarea }) => (
    <div style={{ marginBottom:16 }}>
      <label style={{ fontSize:11, fontWeight:700, color:"var(--fc-text-secondary)", display:"block", marginBottom:6, textTransform:"uppercase", letterSpacing:"0.05em" }}>{label}</label>
      {textarea ? (
        <textarea value={form[fKey]} onChange={e=>set(fKey,e.target.value)} placeholder={label} rows={4}
          style={{ width:"100%", boxSizing:"border-box", padding:"10px 12px", border:"1.5px solid var(--fc-border)", borderRadius:9, fontSize:13, outline:"none", fontFamily:"inherit", color:"var(--fc-text-primary)", background:"var(--fc-card-bg)", resize:"vertical", transition:"all 0.18s" }}
          onFocus={e=>{e.target.style.borderColor="#2563EB"}} onBlur={e=>{e.target.style.borderColor="var(--fc-border)"}} />
      ) : (
        <input type={type} value={form[fKey]} onChange={e=>set(fKey,e.target.value)} placeholder={label}
          style={{ width:"100%", boxSizing:"border-box", padding:"10px 12px", border:"1.5px solid var(--fc-border)", borderRadius:9, fontSize:13, outline:"none", fontFamily:"inherit", color:"var(--fc-text-primary)", background:"var(--fc-card-bg)", transition:"all 0.18s" }}
          onFocus={e=>{e.target.style.borderColor="#2563EB";e.target.style.boxShadow="0 0 0 3px rgba(79,70,229,0.1)"}}
          onBlur={e=>{e.target.style.borderColor="var(--fc-border)";e.target.style.boxShadow="none"}} />
      )}
    </div>
  );

  return (
    <div>
      <div style={{ marginBottom:20 }}>
        <h1 style={{ fontSize:20, fontWeight:800, color:"var(--fc-text-primary)", margin:0 }}>Edit Profile</h1>
        <p style={{ fontSize:13, color:"var(--fc-text-muted)", margin:"3px 0 0" }}>Update your personal and account information</p>
      </div>

      {loading ? (
        <div style={{ background:"var(--fc-card-bg)", border:"1px solid var(--fc-border)", borderRadius:16, padding:28 }}>
          <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
            {[1,2,3,4].map(i => <div key={i} style={{ height:44, background:"var(--fc-border-light)", borderRadius:9 }} />)}
          </div>
        </div>
      ) : (
        <div style={{ display:"flex", flexDirection:"column", gap:16, maxWidth:600 }}>
          {/* Login info (read-only) */}
          <div style={{ background:"var(--fc-card-bg)", border:"1px solid var(--fc-border)", borderRadius:16, padding:24, boxShadow:"0 1px 4px rgba(0,0,0,0.04)" }}>
            <h2 style={{ fontSize:14, fontWeight:700, color:"var(--fc-text-primary)", marginBottom:14, paddingBottom:10, borderBottom:"1px solid var(--fc-border-light)" }}>Login Information</h2>
            <div style={{ marginBottom:4 }}>
              <label style={{ fontSize:11, fontWeight:700, color:"var(--fc-text-secondary)", display:"block", marginBottom:6, textTransform:"uppercase", letterSpacing:"0.05em" }}>Login Email</label>
              <input value={loginEmail} disabled
                style={{ width:"100%", boxSizing:"border-box", padding:"10px 12px", border:"1.5px solid var(--fc-border)", borderRadius:9, fontSize:13, color:"var(--fc-text-subtle)", background:"var(--fc-bg-light)", fontFamily:"inherit" }} />
              <div style={{ fontSize:11, color:"var(--fc-text-subtle)", marginTop:4 }}>Login email cannot be changed.</div>
            </div>
          </div>

          {/* Profile details */}
          <div style={{ background:"var(--fc-card-bg)", border:"1px solid var(--fc-border)", borderRadius:16, padding:24, boxShadow:"0 1px 4px rgba(0,0,0,0.04)" }}>
            <h2 style={{ fontSize:14, fontWeight:700, color:"var(--fc-text-primary)", marginBottom:14, paddingBottom:10, borderBottom:"1px solid var(--fc-border-light)" }}>Profile Information</h2>

            {/* Avatar */}
            <div style={{ display:"flex", alignItems:"center", gap:16, marginBottom:20 }}>
              <div style={{ width:64, height:64, borderRadius:14, background:"var(--fc-border-light)", border:"2px solid var(--fc-border)", overflow:"hidden", flexShrink:0 }}>
                {avatar ? <img src={avatar} alt="Avatar" style={{ width:"100%", height:"100%", objectFit:"cover" }} /> : <div style={{ width:"100%", height:"100%", display:"flex", alignItems:"center", justifyContent:"center" }}><i className="fa-solid fa-user" style={{ fontSize:24, color:"var(--fc-text-subtle)" }} /></div>}
              </div>
              <div>
                <label htmlFor="avatar-upload">
                  <div className="fc-btn fc-btn-sm fc-btn-secondary fc-btn-pill" style={{ display:"inline-flex", alignItems:"center", gap:6, cursor:"pointer" }}>
                    {avatarBusy ? <><i className="fa-solid fa-spinner fa-spin" style={{fontSize:10}} /> Uploading...</> : <><i className="fa-solid fa-upload" style={{fontSize:10}} /> Upload Photo</>}
                  </div>
                </label>
                <input id="avatar-upload" type="file" accept="image/*" onChange={handleAvatarUpload} style={{ display:"none" }} />
              </div>
            </div>

            {success && <div style={{ padding:"10px 12px", background:"var(--fc-green-light)", border:"1px solid var(--fc-green-border)", borderRadius:9, marginBottom:14, fontSize:13, color:"var(--fc-green-text)" }}><i className="fa-solid fa-circle-check" style={{marginRight:7}} />{success}</div>}
            {error   && <div style={{ padding:"10px 12px", background:"var(--fc-red-light)", border:"1px solid var(--fc-red-border)", borderRadius:9, marginBottom:14, fontSize:13, color:"#DC2626" }}><i className="fa-solid fa-circle-exclamation" style={{marginRight:7}} />{error}</div>}

            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"0 16px" }}>
              <Field label="First Name" fKey="firstName" />
              <Field label="Last Name"  fKey="lastName" />
            </div>
            <Field label="Job Role / Title" fKey="jobRole" />
            <Field label="Bio" fKey="bio" textarea />

            <div style={{ display:"flex", justifyContent:"flex-end" }}>
              <button onClick={handleSave} disabled={busy} className="fc-btn fc-btn-md fc-btn-primary fc-btn-pill" style={{ minWidth:160 }}>
                {busy ? <><i className="fa-solid fa-spinner fa-spin" style={{fontSize:12}} /> Saving...</> : "Update Profile"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
